<template >
  <article class="accessIndex" v-if="loaded">
    <div class="accessIndex__general_info states_conventions__container">
      <div class="states_conventions__item">
        <div class="states_conventions__item--dot sended"></div>
        <p class="states_conventions__item--text">Enviadas</p>
      </div>
      <div class="states_conventions__item">
        <div class="states_conventions__item--dot register"></div>
        <p class="states_conventions__item--text">Registradas</p>
      </div>
      <div class="states_conventions__item">
        <div class="states_conventions__item--dot joined"></div>
        <p class="states_conventions__item--text">Ingresadas</p>
      </div>
      <div class="states_conventions__item">
        <div class="states_conventions__item--dot expired"></div>
        <p class="states_conventions__item--text">Vencidas</p>
      </div>
    </div>
    <div class="accessIndex__general_info">
      <div class="accessIndex__reload">
        <v-hover>
          <div  @click="pagination_query=false;filterInvitations(true);date_available=false;" slot-scope="{ hover }" class="accessIndex__reload--container" :class="hover?'accessIndex__interaction--hover':''"  >
            <img src="../../../assets/img/reload_blue.svg">
          </div>
        </v-hover>
        <p class="accessIndex__text--title" >Convenios</p>
      </div>
      <div @click="dialog=true" class="accessIndex__access_items--big_button" v-if="getUserType()!='Admin'" >
        <p>ENVIAR NUEVO PASE</p>
      </div>
    </div>
    <div >
      <label @click="$router.push({name: 'agreements_index'})" class="accessIndex__text--normal_user_gray">Convenios</label>
      <label class="accessIndex__text--normal_user_separator"> > </label>
      <label class="accessIndex__text--normal_user">{{$route.params.title}}</label>

    </div>
    <div class="accessIndex__access_items--date_container_generic">
      <app-date-picker v-if="date_available"
        @filterQuery="pagination_query=false;filterInvitations(false,$event)"></app-date-picker>
    </div>

    <section>
      <v-data-table
        :headers="headers"
        :items="invitations"
        hide-actions
        class="elevation-1">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.correo }}</td>
          <td>{{ props.item.in_date }}</td>
          <td class="accessIndex__state_colors">
            <div class="accessIndex__state_colors--container">
              <div v-if="'USED||CREATED||READY_FOR_USE'.includes(props.item.state)"class="accessIndex__state_colors--green_color"></div>
              <div v-if="'USED||READY_FOR_USE'.includes(props.item.state)" class="accessIndex__state_colors--purple_color"></div>
              <div v-if="'USED'.includes(props.item.state)" class="accessIndex__state_colors--blue_color"></div>
              <!-- <div class="accessIndex__state_colors--red_color"></div> -->
            </div>

          </td>
        </template>
      </v-data-table>
    </section>
    <div v-if="invitations.length>0&& pages > 1" class="accessIndex__pagination">
      <v-pagination  color="light-blue darken-3" v-model="pagination.page" :length="pages"></v-pagination>
      <label class="accessIndex__pagination--general_text">{{'de '+invitations_size}}</label>
      <label class="accessIndex__pagination--current_text" v-if="(pagination.page*pagination.rowsPerPage<invitations_size)">{{1+pagination.rowsPerPage*(pagination.page-1)+' - '+pagination.page*pagination.rowsPerPage}}</label>
      <label class="accessIndex__pagination--current_text" v-else>{{1+pagination.rowsPerPage*(pagination.page-1)+' - '+invitations_size+' '}}</label>

    </div>
    <!-- new invitation dialog -->
    <template>
      <v-dialog v-model="dialog" persistent max-width="424px" v-if="getUserType()!='Admin'">

      <v-card>
				<div class="invitation__new">
				  <div class="invitation__new--title">
					<p class="invitation__new_text--title">Enviar cortesía</p>
				  </div>
				  <div class="invitation__new--info_container">
					  <p class="invitation__new_text--small_gray">Cortesía diriga a</p>
					  <div class="invitation__new--email_container">
						<input placeholder="Correo electrónico" type="text" v-model="newemail">
						<div @click="newEmailInCourtesy()" class="invitation__buttons--default">
							<p>AGREGAR</p>
						</div>
					  </div>
					  <!--v-flex xs12>
						<v-text-field label="Correo electrónico" v-model="newemail" required></v-text-field>
					  </v-flex-->

					  <div>
						<v-chip  close v-for="(tag,index) in select"
							color="#E2E2EB" text-color="#353545" v-model="select[index]"
							>
						{{tag}}
						</v-chip>
					  </div>

					  <!-- <div class="invitation__new--date_container">
  						<div class="invitation__new--date_container_item">
  						  <p class="invitation__new_text--small_gray">Válida desde</p>
  						  <v-menu
  							v-model="menunew"
  							:nudge-bottom="10"
  							lazy
  							transition="scale-transition"
  							offset-y
  							full-width
  							min-width="290px"
  							>
  							<template v-slot:activator="{ on }">
  							  <div  @click="datePickerFirstClick2=true"  class="date_picker__selector--invitation" v-on="on" >
    								<p >{{datePickerFirstClick2?datenew:'DD/MM/AAAA'}}</p>
    								<img :src="menu ?'https://s3-us-west-2.amazonaws.com/karrottsportlife/arrow_up.svg':'https://s3-us-west-2.amazonaws.com/karrottsportlife/arrow_down.svg'">
  							  </div>
  							</template>
  							<v-date-picker v-model="datenew" :max="date2new" no-title scrollable>
  							</v-date-picker>
  						  </v-menu>
  						</div>
  						<div class="invitation__new--date_container_item">
  						  <p class="invitation__new_text--small_gray">Válida hasta</p>
  						  <v-menu
  							v-model="menu2new"
  							:nudge-bottom="10"
  							lazy
  							transition="scale-transition"
  							offset-y
  							full-width
  							min-width="290px"
  							>
  							<template v-slot:activator="{ on }">
  							  <div @click="datePickerFirstClick2=true" class="date_picker__selector--invitation" v-on="on" >
    								<p >{{datePickerFirstClick2?date2new:'DD/MM/AAAA'}}</p>
    								<img :src="menu2 ?'https://s3-us-west-2.amazonaws.com/karrottsportlife/arrow_up.svg':'https://s3-us-west-2.amazonaws.com/karrottsportlife/arrow_down.svg'">
  							  </div>
  							</template>
  							<v-date-picker :max="new Date().toISOString().substr(0, 10)" v-model="date2new" no-title scrollable>
  							</v-date-picker>
  						  </v-menu>
  						</div>
					  </div> -->
					  <div class="invitation__new--actions">
						  <p class="invitation__buttons--blue" @click="dialog=false; createInvitation(); datePickerFirstClick2=false;">ENVIAR</p>
						  <p class="invitation__buttons--gray" @click="dialog=false; datePickerFirstClick2=false;">CANCELAR</p>

					  </div>
					</div>
				</div>
      </v-card>
          </v-dialog>
    </template>
  </article>
</template>

<script>
export default {
  data(){
    return{
      saved_default_option:false,
      pagination_query:false,
      date_available:false,
      invitations_size:0,
      dialog: false,
      date: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2:false,
      menunew: false,
      menu2new:false,
      datePickerFirstClick:false,
      datePickerFirstClick2:false,
      pages:2,
      pagination: {page:1,rowsPerPage:24},
      invitations: [],
      loaded: false,
      newemail:'',
      select: [],
      headers: [
        {text:'Correo', value: 'correo'},
        {text:'Fecha disponible', value: 'in_date'},
        {text:'Estado', value: 'state'}
      ],
      months:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre	","Octubre","	Noviembre","Diciembre"],
      data: {
          attributes: {
            user_id: this.getUserId(),
            from: null,
            until: null
          },
          invited_users_attributes:[]
        }

    }
  },
   watch: {
     'pagination.page': function (val, oldVal) {
       if(oldVal!=val&&val!=null&&oldVal!=null&&val==1&&!this.pagination_query){

       }
       else if(oldVal!=val&&val!=null&&oldVal!=null){
         this.pagination_query=true;
         this.filterInvitations(false);

       }

       }
    },
  methods:{
    modifyDateFormatToStatus(datex){
      var entries=datex.split('/');
      entries=[entries[2],entries[0],entries[1]];
      return entries.join("-");
    },
    newEmailInCourtesy(){
      if(this.newemail!=''){
        this.select.push(this.newemail);
        this.newemail='';
      }
    },
    filterEmptyEmails (arr){
        return arr.filter(function(ele){return ele != false});
      },
  	createInvitation(){
        let vm = this;
        this.data.invited_users_attributes = this.filterEmptyEmails(this.select);

        this.data.invited_users_attributes = [...new Set(vm.data.invited_users_attributes.map(item => item))].map(function(x){return {email: x}});
        // alert(JSON.stringify(this.data.invited_users_attributes));
        try {
          this.$http.post('invitations/create', {
            data: this.encrypt(this.data).toString()
          },
          {headers:{
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()
          }}).then(function(response){
            this.select= [];
            this.filterInvitations(true);
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          }, function(response){
            if (response.body.data.message != null &&
                response.body.data.message != undefined &&
                response.body.data.message != '' ){
                alert(response.body.data.message)
            }else{
              alert(response.body.data)
            }
          })
        } catch (e) {
          alert(e.message)
        }

      },
    dateFormat(datex){
        var sections=datex.split("/");
        var index=Number(sections[0])-1;
        sections[0]=this.months[index];
        datex=sections.join(" ");
        return datex;
    },
    monthEarlier(){
      var datex=new Date();
      datex.setMonth(datex.getMonth() - 1);
      return datex.toISOString().substr(0, 10);
    },
    filterInvitations(defaultOption,dates){
      if(this.pagination_query){
        defaultOption=this.saved_default_option;
      }
      else{
        this.pagination.page=1;
      }
      this.saved_default_option=defaultOption;

      var initialDate=this.monthEarlier();
      var lastDate=new Date().toISOString().substr(0, 10);
      if(!defaultOption){
        var object = dates != undefined && dates != null ? dates : {date_from: '', date_to: '' };
        if(object.date_from!='Desde'&&object.date_to!='Hasta'&&object.date_from!=''){
          this.datePickerFirstClick=true;
          this.date = this.modifyDateFormatToStatus(object.date_from);
          this.date2 = this.modifyDateFormatToStatus(object.date_to);
        }
        initialDate=this.date;
        lastDate=this.date2;
      }
      else{
        this.date= this.monthEarlier();
        this.date2= new Date().toISOString().substr(0, 10);
        this.datePickerFirstClick=false;
      }
      try {
        this.$http.get('invitations/index',{
          params:{
            agreement_id: this.$route.params.id,
            type: 'agreement_users',
            offset_time: new Date().getTimezoneOffset(),
            first_date: initialDate,
            last_date: lastDate,
            page:this.pagination.page
          },
          headers:
            {
              "X-Device-ID" : this.getDeviceId(),
              "Authorization" : 'Bearer ' + this.getUserToken()
            }
          }
        ).then(function(response){
          this.invitations= [];
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          var temp=response.body.data;

          for (var i=0;i<temp.length;i++) {


            this.invitations.push({
              correo:temp[i].email,
              in_date:this.dateFormat(this.$moment(temp[i].date).format(" MM/DD/YYYY")),
              state: temp[i].state
            })
          }
          this.invitations_size=response.body.total_elements;
          this.pages=response.body.pages;
          console.table(response.body.data)
          this.loaded = true;
          this.date_available=true;
        }, function(response){
          if (response.body.data.message != null &&
              response.body.data.message != undefined &&
              response.body.data.message != '' ){
              alert(response.body.data.message)
          }else{
            alert(response.body.data)
          }
        })
      } catch (e) {
        alert(e.message)
      }
    }

  },
  mounted(){
    this.date= this.monthEarlier();
    this.pagination.rowsPerPage=12;
    this.filterInvitations(true);

  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/agreements/Index_agreement.vue